import { createContext, useContext, type Context } from 'react';
import type { FormApi } from './types.js';

export const FormContext: Context<FormApi | null> = createContext<FormApi | null>(null);

export function useFormApi(): FormApi {
  const ctx = useContext(FormContext);
  if (ctx === null) throw new Error('useFormApi must be used inside a <Form>');
  return ctx;
}

export interface FieldContextValue {
  readonly name: string;
  readonly id: string;
  readonly errorId: string;
  readonly describedBy: string | undefined;
}

export const FieldContext: Context<FieldContextValue | null> =
  createContext<FieldContextValue | null>(null);

export function useFieldContext(): FieldContextValue {
  const ctx = useContext(FieldContext);
  if (ctx === null) throw new Error('useFieldContext must be used inside a <FormField>');
  return ctx;
}
